import React from 'react';
import './BarcodeNotFound.css';

export interface BarcodeNotFoundProps {
  barcode: string;
  onClear: () => void;
  className?: string;
}

const BarcodeNotFound: React.FC<BarcodeNotFoundProps> = ({
  barcode,
  onClear,
  className = ""
}) => {
  return (
    <div className={`barcode-not-found ${className}`}>
      <div className="barcode-not-found__content">
        <div className="barcode-not-found__status-row">
          <span className="barcode-not-found__status-badge">
            Unrecognized barcode
          </span>
        </div>
        <div className="barcode-not-found__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        
        <h3 className="barcode-not-found__title">
          Product Not Found
        </h3>
        
        <p className="barcode-not-found__message">
          This barcode does not match any product in your Grocy setup.
        </p>
        
        <div className="barcode-not-found__barcode">
          Scanned: {barcode}
        </div>
        
        <button
          onClick={onClear}
          className="barcode-not-found__clear-button"
        >
          Scan Another Item
        </button>
      </div>
    </div>
  );
};

export default BarcodeNotFound; 
